import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

const useDetailsValidator = () => useValidator(validators.compose(validators.requiredNumber('vehiclePrice')));

export default useDetailsValidator;
